<!--事件列表界面 deviceList 设备列表-->
<template>
  <div class="eventsBody">
    <div class="title">
      <span class="li">
        <div class="name">设备类型</div>
        <el-select v-model="value" placeholder="请选择">
          <el-option
            v-for="(item, i) in options"
            :key="i"
            :label="item"
            :value="i"
          >
          </el-option>
        </el-select>
      </span>
      <span class="li">
        <div class="name">设备名称</div>
        <el-input v-model="input" placeholder="请输入设备名称"></el-input>
      </span>
      <span class="li">
        <el-button
          type="primary"
          style=" height: 35px; line-height: 35px; padding: 0; width: 76px; "
          >查询</el-button
        >
      </span>
    </div>
    <div class="content">
      <el-table
        id="demo"
        :header-cell-style="{
          color: '#333',
          fontFamily: 'MicrosoftYaHeiUI',
          fontSize: '14px',
          fontWeight: 900,
          backgroundColor: '#f5f7fa',
        }"
        stripe
        :data="tableData"
        border
        style="width: 100%"
        row-key="Id"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      >
        <template slot="empty">
          <span class="noData">
            <img src="../../assets/noData.png" alt="暂无数据" />
            <span class="text">暂无数据</span>
          </span>
        </template>
        <el-table-column type="index" label="#" width="50" align="center">
        </el-table-column>
        <el-table-column
          v-for="(item, index) in columns"
          :prop="item.key"
          :label="item.name"
          align="center"
          :width="item.width"
        >
          <template #default="{row}">
            <span v-if="item.key == 'c'">
              <el-tag type="success" v-if="row[item.key]">正常</el-tag>
              <el-tag type="danger" v-else>断开</el-tag>
            </span>
            <span v-else>{{ row[item.key] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" min-width="230">
          <template #default="{row}">
            <el-button
              type="primary"
              style=" height: 31px; line-height: 31px; padding: 0; width: 76px; "
              >位置
            </el-button>
            <el-button
              type="success"
              style=" height: 31px; line-height: 31px; padding: 0; width: 76px; "
              >详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <span class="pagination">
        <el-pagination background layout="prev, pager, next" :total="1000">
        </el-pagination>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      columns: [
        {
          name: "设备名称",
          key: "a",
        },
        {
          name: "设备类型",
          key: "b",
        },
        {
          name: "通讯状态",
          key: "c",
        },
        {
          name: "安装位置",
          key: "d",
        },
        {
          name: "故障状态",
          key: "e",
        },
        {
          name: "运行状态",
          key: "f",
        },
        {
          name: "实时功率",
          key: "g",
        },
        {
          name: "运行时长",
          key: "h",
        },
        {
          name: "维护次数",
          key: "i",
        },
      ],
      tableData: [
        {
          a: "1#一用一备",
          b: "动力设备",
          c: true,
          d: "1h号楼顶",
          e: "无",
          f: "正常",
          g: "3455kwh",
          h: "165h",
          i: "3",
        },
        {
          a: "1#一用一备",
          b: "动力设备",
          c: true,
          d: "1h号楼顶",
          e: "无",
          f: "正常",
          g: "3455kwh",
          h: "165h",
          i: "3",
        },
        {
          a: "1#一用一备",
          b: "动力设备",
          c: true,
          d: "1h号楼顶",
          e: "无",
          f: "正常",
          g: "3455kwh",
          h: "165h",
          i: "3",
        },
        {
          a: "1#一用一备",
          b: "动力设备",
          c: true,
          d: "1h号楼顶",
          e: "无",
          f: "正常",
          g: "3455kwh",
          h: "165h",
          i: "3",
        },
        {
          a: "1#一用一备",
          b: "动力设备",
          c: true,
          d: "1h号楼顶",
          e: "无",
          f: "正常",
          g: "3455kwh",
          h: "165h",
          i: "3",
        },
        {
          a: "1#一用一备",
          b: "动力设备",
          c: true,
          d: "1h号楼顶",
          e: "无",
          f: "正常",
          g: "3455kwh",
          h: "165h",
          i: "3",
        },
      ],
      input: "",
      value: 0,
      options: ["动力设备", "电力设备"],
    };
  },
};
</script>

<style scoped>
.eventsBody {
  box-sizing: border-box;
  padding: 15px;
}

.eventsBody .title {
  display: flex;
  background: #fff;
  padding-left: 30px;
  height: 70px;
}

.eventsBody .title .li {
  display: flex;
  align-items: center;
  margin-right: 20px;
}

.eventsBody .title .li .name {
  white-space: nowrap;
  margin-right: 15px;
}

.content {
  background: #fff;
  padding: 20px 30px;
}

.pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}
</style>
